import React from 'react';

import Loader from './loader';

import styles from './styles/form-loading-spinner.module.scss';

type Props = {
  isVisible?: boolean;
};

const FormLoadingSpinner = ({isVisible}: Props) =>
  isVisible ? (
    <div className={styles.wrapper}>
      <Loader className={styles.loader} />
    </div>
  ) : null;

export default FormLoadingSpinner;
